/**
 * First-run terms & privacy acceptance.
 *
 * Apiboo is local-first: a user can do real work without ever creating an
 * account, so they never see the "by continuing you agree" line on the sign-in
 * modal. This is the only point at which those users are shown the terms.
 *
 * Acceptance is recorded LOCALLY and nothing is sent anywhere. Recording it
 * server-side would mean minting a per-device identifier for anonymous users —
 * exactly the thing the install telemetry was removed for. For users who do
 * sign in, the contractual acceptance already happens at registration, where
 * there is a real identity to attach it to.
 *
 * Bump TERMS_VERSION when the terms change materially: the screen shows again
 * and the new version is recorded, so the accepted revision is unambiguous.
 *
 * The screen itself is the Welcome step of the onboarding carousel
 * (onboarding/OnboardingDialog.js, 24.09.2026); this module keeps the record.
 */
export const TERMS_VERSION = '2026-08-02';

const ACCEPTED_VERSION_KEY = 'apiboo.terms.acceptedVersion';
const ACCEPTED_AT_KEY = 'apiboo.terms.acceptedAt';

/** True when this build's terms have not been accepted on this device yet. */
export function needsTermsAcceptance() {
  try {
    return localStorage.getItem(ACCEPTED_VERSION_KEY) !== TERMS_VERSION;
  } catch {
    // Storage unavailable — do not block the app on a consent screen we could
    // never record the answer to.
    return false;
  }
}

export function recordTermsAcceptance() {
  try {
    localStorage.setItem(ACCEPTED_VERSION_KEY, TERMS_VERSION);
    localStorage.setItem(ACCEPTED_AT_KEY, new Date().toISOString());
  } catch {
    // Non-fatal: the user still accepted, we just cannot remember it.
  }
}
